import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export const AddEditCarModal = ({ open, onClose, onSubmit, car = null, loading }) => {
  const { t } = useTranslation('cars');
  const [name, setName] = React.useState(car?.name || '');
  const [notes, setNotes] = React.useState(car?.notes || '');

  React.useEffect(() => {
    if (car) {
      setName(car.name);
      setNotes(car.notes || '');
    } else {
      setName('');
      setNotes('');
    }
  }, [car]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ name, notes });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {car ? t('cars.modal.editTitle') : t('cars.modal.addTitle')}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={t('cars.modal.nameLabel')}
            placeholder={t('cars.modal.namePlaceholder')}
            type="text"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            disabled={loading}
          />
          <TextField
            margin="dense"
            label={t('carDetail.notes')}
            placeholder={t('cars.modal.notesPlaceholder')}
            multiline
            rows={4}
            fullWidth
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            disabled={loading}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            {t('cars.actions.cancel')}
          </Button>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary" 
            disabled={loading || !name.trim()}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {car ? t('cars.actions.save') : t('cars.actions.add')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export const DeleteCarModal = ({ open, onClose, onConfirm, loading }) => {
  const { t } = useTranslation('cars');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('carDetail.deleteCar')}</DialogTitle>
      <DialogContent>
        <Typography>{t('carDetail.confirmDelete')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t('cars.actions.cancel')}
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained" 
          disabled={loading}
        >
          {t('common:actions.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 